module.exports = __webpack_public_path__ + "0d0ed9e00dbe0877755cfcc340e10f61.pdf";